import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import CultivarForm from '@galo-monitor/web-containers/forms/root/CultivarForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const CultivarModal = (props) => {
  const {
    id,
    open,
    handleClose,
    cultivar,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const { createDialog } = useDialog()
  const t = useT()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    response => {
      setLoading(false)
      createDialog({
        id: 'error-cultivar-modal',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t('update')),
            this: toLower(t('cultivar', { howMany: 1 }))
          })  }.`,
          message: t(response?.data?.message ?? response?.data?.errors?.[0]?.message)
        }
      })
    },
    [createDialog, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', { this: t('cultivar', { howMany: 1 }) }) }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <CultivarForm
        ref={ formRef }
        cultivar={ cultivar }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

CultivarModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  cultivar: PropTypes.object
}

CultivarModal.defaultProps = {
  cultivar: {}
}

export default CultivarModal
